import React from "react";
import { shape, array } from "prop-types";

import { Link } from "@quintype/components";

import Headline from "../../atoms/headline";
import Table from "../../rows/table";
import CustomFilters from "../../organisms/custom-filters";

import "./housing-auction.m.css";

const headers = [
  {
    key: "description-of-property",
    name: "Description of Property"
  },
  {
    key: "area-sqft-detail",
    name: "Area Sq. Ft."
  },
  {
    key: "inspection-date-time",
    name: "Inspection Date & Time"
  },
  {
    key: "reserved-price",
    name: "Reserved Price (Rs In Lakh)"
  },
  {
    key: "auction-place-date-time",
    name: "Auction Place Date & Time"
  },
  {
    key: "contact-details",
    name: "Contact Details"
  }
];

class HousingAuctionPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tableData: [],
      isReadMore: true
    };
  }

  componentDidMount() {
    this.updateTableData(this.props.data.auction);
  }

  updateTableData = tableData => {
    this.setState({ tableData });
  };

  onUpdateFilters = tableData => {
    this.updateTableData(tableData);
  };

  toggleReadMore = () => {
    this.setState({ isReadMore: !this.state.isReadMore });
  };

  render() {
    const { auction, locations } = this.props.data;
    return (
      <div styleName="container">
        <div styleName="header-image">
          <img
            src={`https://thumbor-stg.assettype.com/freepressjournal/2020-06/bed94f12-87e2-42aa-9f1a-3f4958032481/property_auction.jpg`}
            alt="Housing Auction"
          />
        </div>
        <div styleName="section-header">
          <Link href="/housing-auction">
            <Headline text="PROPERTY DEALS" headerType={12} headerLevel={1} />
          </Link>
        </div>
        <div>
          <p>
            The cheaper and smarter way of buying your dream home: <b>A 7-step guide</b>
          </p>
          <br />

          <p>
            The Free Press Journal has listings for auction of bank foreclosed properties including movable and
            immovable properties from all the leading public sector as well as private banks.
          </p>
          <p>
            For buyers below information provides an opportunity to own a property at a price substantially lower than
            the market price.
          </p>
          {this.state.isReadMore && (
            <div>
              <div styleName="content-read">
                <div styleName="content-read-more" onClick={this.toggleReadMore}>
                  ...Read More
                </div>
              </div>
              <br />
            </div>
          )}
          {!this.state.isReadMore && (
            <div>
              <br />
              <p>
                However, instead of going through a broker to buy an auctioned flat, you can buy it yourself in the
                following steps
              </p>
              <p>
                <b>Step 1</b>: Search for bank auction property: You can check them regularly in The Free Press Journal
                newspaper (
                <Link href="https://epaper.freepressjournal.in/" target="_blank" styleName="anchor">
                  epaper.freepressjournal.in
                </Link>{" "}
                or on the website{" "}
                <Link href="https://www.freepressjournal.in/" target="_blank" styleName="anchor">
                  www.freepressjournal.in
                </Link>
                . The property could be land, home or office.
              </p>
              <br />
              <p>
                <b>Step 2</b>: Check out the property details: If you’re seriously considering the house, then you will
                be required to check out the property details by yourself. This is because you will not get access to
                paperwork unless you purchase the property.
              </p>
              <br />
              <p>
                <b>Step 3</b>: Physically inspect the property: Once you’ve done an online recce of the property, it is
                your responsibility to visit the property. It’s advisable to buy a home which the bank has physical
                possession.
              </p>
              <br />
              <p>
                <b>Step 4</b>: Submit a tender form: Along with the tender form, you should deposit the Earnest Money
                Deposit. Payment usually involves cheque or demand draft.
              </p>
              <br />
              <p>
                <b>Step 5</b>: Usually the tender form and the bidding form are the same. In an e-auction, you can bid
                multiple times.
              </p>
              <br />
              <p>
                <b>Step 6</b>: Auction date: The date can be at a location or can be online. You can check whether you
                won the bid.
              </p>
              <br />
              <p>
                <b>Step 7</b>: Sale certificate you will receive a sale certificate after you pay the money. However,
                the title transfer is incomplete till you register sale certificate in sub-registrar office. Once this
                is done, you get possession of your home.
              </p>
              <div styleName="content-read">
                <div styleName="content-read-more" onClick={this.toggleReadMore}>
                  Less
                </div>
              </div>
              <br />
            </div>
          )}
        </div>
        <div styleName="wrapper">
          <CustomFilters data={auction} searchData={locations} onUpdateFilters={this.onUpdateFilters} />
          <div styleName={this.state.tableData.length > 0 ? "table" : "table-empty"}>
            {this.state.tableData.length ? (
              <Table data={this.state.tableData} headers={headers} />
            ) : (
              <div>No results found...</div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

HousingAuctionPage.propTypes = {
  data: shape({
    locations: array,
    auction: array
  })
};

export { HousingAuctionPage };
